import { z } from "zod";
import { phoneSchema } from "../common/phone.js";
export const updateTenantSchema = z.object({
    first_name: z.string().min(1).max(100).optional(),
    last_name: z.string().min(1).max(100).optional(),
    phone: phoneSchema,
    address: z.string().max(500).optional(),
});
